import { useState, useEffect, useRef } from "react";

export const ExpandableBtn = ({ label, ariaLabel, context }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    return (
        <div className="relative inline-block" ref={containerRef}>
            <button
                onClick={() => setIsOpen(!isOpen)}
                className={`
                    cursor-pointer inline-flex items-center px-2 py-0 rounded-xl text-[13px] gap-1 transition-colors focus:outline-none
                    ${isOpen 
                        ? 'bg-blue-100 text-blue-700 dark:bg-blue-600 dark:text-blue-200' 
                        : 'bg-gray-200 text-gray-600 hover:bg-gray-300 dark:bg-zinc-600 dark:text-gray-300 dark:hover:bg-zinc-500/80'}
                `}
                aria-label={ariaLabel}
                aria-expanded={isOpen}
            >
                {label}
            </button>

            {isOpen && (
                <div 
                    className="
                        absolute top-full left-1/2 -translate-x-1/2 mt-2 z-50 w-max min-w-[120px] p-3
                        bg-white dark:bg-zinc-800 border border-gray-200 dark:border-zinc-700 
                        rounded-lg shadow-xl animate-in fade-in zoom-in-95 duration-200"
                >
                    <div className="absolute -top-1 left-1/2 -translate-x-1/2 w-2 h-2 bg-white dark:bg-zinc-800 border-t border-l border-gray-200 dark:border-zinc-700 rotate-45"></div>
                    <div className="text-sm text-gray-700 dark:text-gray-200 leading-relaxed">{context}</div>
                </div>
            )}
        </div>
    );
};